import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const StyledItemWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${token.spacing4};
`;

export const StyledSelectedIndicator = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 ${token.spacing4};
    color: ${token.blue500};
    pointer-events: none;
`;

export const StyledListItemWrapper = styled.div`
    flex: 1;
    min-width: 0;
`;
